// extracted by mini-css-extract-plugin
export default {"chevron":"styles-module--chevron--u6r8e","showBorderMedium":"styles-module--showBorderMedium--VUMiH"};